<template>
  <div class="loader-overlay">
  </div>
  <div class="loader-modal">
    <div class="square">
      <div
        class="square-item"
        :class="`square-item-${i}`"
        v-for="i in 9"
        :key="i"
      >
      </div>
    </div>
    <div class="text">{{text}}</div>
  </div>

</template>

<script>

export default {
  props: {
    text: {
      type: String,
      default: "잠시만 기다려주세요."
    }
  }
}

</script>

<style lang="scss" scoped>
.loader-overlay {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(#000, 0.25);
  z-index: 100;
}

.loader-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 280px;
  height: 230px;
  transform: translate3d(-50%, -50%, 0);
  background-color: white;
  box-shadow: 0px 8px 16px rgba(32, 32, 32, 0.15);
  border-radius: 8px;
  z-index: 110;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.text {
  margin: 16px 0 0;
  color: var(--gray-900);
  font-size: var(--typ-body5);
  font-weight: 700;
}

.square {
  display: grid;
  grid-template-columns: repeat(3, 18px);
  grid-gap: 5px;
}



.square-item {
  width: 18px;
  height: 18px;
  background-color: var(--primary-100);
  border-radius: 2px;
  animation: square 900ms ease-in infinite;
}

.square-item-5 {
  animation: none;
}

.square-item-1 {
  animation-delay: 0;
}
.square-item-2 {
  animation-delay: 100ms;
}
.square-item-3 {
  animation-delay: 200ms;
}
.square-item-6 {
  animation-delay: 300ms;
}
.square-item-9 {
  animation-delay: 400ms;
}
.square-item-8 {
  animation-delay: 500ms;
}
.square-item-7 {
  animation-delay: 600ms;
}
.square-item-4 {
  animation-delay: 700ms;
}


// @keyframes square {
//   0% {
//     background-color: var(--primary-500);
//   }
//   20% {
//     background-color: var(--primary-400);
//   }
//   40% {
//     background-color: var(--primary-300);
//   }
//   60% {
//     background-color: var(--primary-200);
//   }
//   80% {
//     background-color: var(--primary-200);
//   }
//   100% {
//     background-color: var(--primary-100);
//   }
// }
@keyframes square {
  0% {
    background-color: var(--primary-500);
  }
  20% {
    background-color: var(--primary-400);
  }
  40% {
    background-color: var(--primary-300);
  }
  60% {
    background-color: var(--primary-200);
  }
  80% {
    background-color: var(--primary-200);
  }
  100% {
    background-color: var(--primary-100);
  }
}

</style>